import {
    POST_ON_CALL_POLICY, POST_ON_CALL_POLICY_FAIL, POST_ON_CALL_POLICY_SUCCESS, GET_ON_CALL_POLICY_SUCCESS, GET_ON_CALL_POLICY_FAIL, GET_ON_CALL_POLICY, GET_SPECIFIC_ON_CALL_POLICY, GET_SPECIFIC_ON_CALL_POLICY_FAIL, GET_SPECIFIC_ON_CALL_POLICY_SUCCESS, EDIT_ON_CALL_POLICY_SUCCESS, EDIT_ON_CALL_POLICY_FAIL, EDIT_ON_CALL_POLICY, DELETE_SPECIFIC_ON_CALL_POLICY_SUCCESS, DELETE_SPECIFIC_ON_CALL_POLICY_FAIL, DELETE_SPECIFIC_ON_CALL_POLICY, GET_ONCALL_ELIGIBLE_USERS_SUCCESS, GET_ONCALL_ELIGIBLE_USERS_FAIL, GET_ONCALL_ELIGIBLE_USERS
} from "./actionTypes";

const INIT_STATE = {
    policies: [],
    policy: [],
    specific_policy: [],
    modified_policy: [],
    policy_deleted: [],
    oncall_eligible_users: [],
};

const onCallPolicy = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ON_CALL_POLICY:
            return {
                ...state,
                error: action.payload,
            }

        case GET_ON_CALL_POLICY_SUCCESS:
            return {
                ...state,
                policies:action.payload
            }

        case GET_ON_CALL_POLICY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_SPECIFIC_ON_CALL_POLICY:
            return {
                ...state,
                error: action.payload,
            }

        case GET_SPECIFIC_ON_CALL_POLICY_SUCCESS:
            return {
                ...state,
                specific_policy: action.payload
            }

        case GET_SPECIFIC_ON_CALL_POLICY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_SPECIFIC_ON_CALL_POLICY:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_SPECIFIC_ON_CALL_POLICY_SUCCESS:
            return {
                ...state,
                policy_deleted: Object.assign(state.policy_deleted, action.payload)
            }

        case DELETE_SPECIFIC_ON_CALL_POLICY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case POST_ON_CALL_POLICY:
            return {
                ...state,
                error: action.payload,
            }

        case POST_ON_CALL_POLICY_SUCCESS:
            return {
                ...state,
                policy: Object.assign(state.policy, action.payload)
            }

        case POST_ON_CALL_POLICY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EDIT_ON_CALL_POLICY:
            return {
                ...state,
                error: action.payload,
            }

        case EDIT_ON_CALL_POLICY_SUCCESS:
            return {
                ...state,
                modified_policy: Object.assign(state.modified_policy, action.payload)
            }

        case EDIT_ON_CALL_POLICY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_ONCALL_ELIGIBLE_USERS:
            return {
                ...state,
                error: action.payload,
            }

        case GET_ONCALL_ELIGIBLE_USERS_SUCCESS:
            return {
                ...state,
                oncall_eligible_users: Object.assign(state.oncall_eligible_users, action.payload)
            }

        case GET_ONCALL_ELIGIBLE_USERS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default onCallPolicy;